import { ScopedFolderMembership } from '@st/sdk'
import { rank, sort } from '@st/util/sort'
import { match, P } from '@st/pattern'

export type FolderMembershipSide = 'firm' | 'client'

export function folderMembershipSide(
  memberships: ScopedFolderMembership[],
  userId: string
): FolderMembershipSide | undefined {
  // A user can appear at both folder + organization scope; prefer organization scope so
  // firm users with folder access (assignee/client workflows) are still classified as firm.
  const [membership] = sort(
    memberships.filter((membership) => membership.user.id == userId),
    rank('scope', ['organization', 'folder'])
  )

  return match<ScopedFolderMembership | undefined, FolderMembershipSide | undefined>(membership)
    .with(undefined, () => undefined)
    .with({ role: 'client' }, () => 'client')
    .with({ role: P.union('owner', 'member', 'restricted', 'assignee') }, () => 'firm')
    .exhaustive()
}
